exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "healthcarebook-responsive-component .card-body img {\n  max-height: 550px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/health-care-book/language/language.css
// module id = 519
// module chunks = 0